import type { VNode } from 'vue';

export enum ButtonLayout {
	Default = 'btn btn-secondary btn-simple',
	Primary = 'btn btn-primary',
	PrimaryInverted = 'btn btn-primary btn-primary-inverted',
	Secondary = 'btn btn-secondary',
	Info = 'btn btn-info',
	Success = 'btn btn-success',
	Warning = 'btn btn-warning',
	Danger = 'btn btn-danger',
	Plain = 'btn',
}

export enum ButtonSize {
	Regular = '',
	Small = 'btn-sm',
	Large = 'btn-lg',
	ExtraLarge = 'btn-xl',
}

export enum ButtonIframeHandling {
	Both = 0,
	LocalOnly = 1,
	PostOnly = 2,
}

export interface _ButtonArgsBase {
	layout: ButtonLayout;
	text?: string | VNode;
	size?: ButtonSize;
	round?: boolean;
	outlined?: boolean;
	icon?: string;
	iconButton?: boolean;
	iconOnRight?: boolean;
	cssClass?: string;
	dismissModal?: boolean;
	disabled?: boolean;
	fullWidth?: boolean;
	tooltip?: string;
	pulsate?: boolean;
	ariaLabel?: string;
}

export enum ButtonSocialType {
	Google = 'google',
	Facebook = 'facebook',
	Apple = 'apple',
	X = 'x',
	Figma = 'figma',
	Dribble = 'dribble',
}

export enum ButtonMobileAppStoreType {
	GooglePlay = 'google-play',
	AppStore = 'app-store',
	GalaxyStore = 'galaxy-store',
	HuaweiAppGallery = 'huawei-app-gallery',
}
